var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit Image Photo",
    clipPath: "url(#clip0_30_12298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-image-photo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27679 0C2.57349 0 1.899 0.279384 1.40169 0.77669C0.904384 1.274 0.625 1.94849 0.625 2.65179L0.625 17.9732C0.625 18.6765 0.904384 19.351 1.40169 19.8483C1.899 20.3456 2.57349 20.625 3.27679 20.625H8.7483C8.6122 20.3129 8.56529 19.9692 8.61277 19.6321L8.77777 18.4608H3.5346C3.33689 18.4608 3.14729 18.3823 3.00749 18.2425C2.86769 18.1027 2.78915 17.9131 2.78915 17.7154V10.3184C5.60293 10.2405 8.39087 10.8739 10.8948 12.1599C11.1806 12.3676 11.5754 12.6652 12.0115 13.007L16.4989 8.51076C16.6699 8.33949 16.873 8.20361 17.0966 8.11091C17.3202 8.0182 17.5599 7.97048 17.8019 7.97048C18.044 7.97048 18.2837 8.0182 18.5073 8.11091C18.7308 8.20361 18.934 8.33949 19.105 8.51076L21.25 10.6528V2.65179C21.25 2.30355 21.1814 1.95872 21.0481 1.63699C20.9149 1.31526 20.7196 1.02293 20.4733 0.77669C20.2271 0.530449 19.9347 0.33512 19.613 0.201855C19.2913 0.0685905 18.9465 0 18.5982 0L3.27679 0ZM16.0481 5.28884C16.0481 5.7259 15.9185 6.15315 15.6757 6.51655C15.4328 6.87995 15.0877 7.16319 14.6839 7.33045C14.2801 7.4977 13.8358 7.54147 13.4071 7.4562C12.9785 7.37093 12.5847 7.16047 12.2757 6.85142C11.9666 6.54237 11.7562 6.14862 11.6709 5.71995C11.5856 5.29129 11.6294 4.84697 11.7966 4.44318C11.9639 4.03938 12.2471 3.69426 12.6105 3.45144C12.974 3.20862 13.4012 3.07902 13.8383 3.07902H13.9046C15.0875 3.07902 16.0481 4.03808 16.0481 5.22254V5.28884ZM10.6384 18.4594L10.4366 19.8869L13.5746 19.4597L20.5134 12.5223L17.8027 9.81161L10.8786 16.7504L10.6384 18.4608V18.4594Z",
    fill: "#838383"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_12298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.625,
    height: 20.625,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3761d8d81e1e69d5faf202dac3f03a77.svg";
export { ForwardRef as ReactComponent };